import React, { Component } from 'react'
import { func, shape, number, bool } from 'prop-types'
import { translate } from 'react-i18next'
import { Price } from '../ui/inputs/Price'
import { PaymentDescription } from './PaymentDescription'
import { stores } from '../../stores'

class ByWalletComponent extends Component {
  constructor () {
    super()
    this.state = { loading: false }
  }

  componentDidMount () {
    if (this.props.isWalletJustFed) {
      const paymentAnchor = document.getElementById('payment')
      this.scrollToPayment(paymentAnchor)
    }
  }
  scrollToPayment (anchor) { anchor.scrollIntoView({ behavior: 'smooth', block: 'start' }) }

  get amountToPay () {
    const { payment } = this.props
    return payment.advance || payment.total
  }

  get canPay () {
    const { payment } = this.props
    return payment.balance - this.amountToPay >= 0
  }

  get disabled () {
    return !this.canPay || this.state.loading
  }

  submit ({ paymentType }) {
    if (this.disabled) { return }
    this.setState({ loading: true })
    stores.inquiries.accept({ mean: 'credit', paymentType })
  }

  render () {
    const { t, payment, iban, asAdmin } = this.props

    return (
      <div>
        <PaymentDescription payment={payment} iban={iban} />
        <div className='paiement__body__credit'>
          <div className='paiement__body__credit__line'>
            <span className='paiement__body__credit__line__title'>{t('common:payment:available')} :</span>
            <span className='paiement__body__credit__line__value'><Price value={payment.balance} /></span>
          </div>
          <div className='paiement__body__credit__line'>
            <span className='paiement__body__credit__line__title'>{t('common:payment:available_after')} :</span>
            <span className='paiement__body__credit__line__value'><Price value={payment.balance - this.amountToPay} /></span>
          </div>
        </div>
        <div className='paiement__body__validate' id='payment'>
          { asAdmin ? <div>
            <button
              onClick={() => this.submit({ paymentType: 'CHEQUE' })}
              className={`${!this.disabled ? 'btn--red' : 'btn--disabled'} layout--centered`}
              style={{background: 'red'}}
              disabled={this.disabled}>{t('common:payment:payment_cmj_account_cheque')}</button>
            <button
              onClick={() => this.submit({ paymentType: 'CESU' })}
              className={`${!this.disabled ? 'btn--red' : 'btn--disabled'} layout--centered`}
              style={{background: 'red'}}
              disabled={this.disabled}>{t('common:payment:payment_cmj_account_cesu')}</button>
          </div> : '' }
          <button
            onClick={() => this.submit({})}
            className={`${!this.disabled ? 'btn--green' : 'btn--disabled'} layout--centered`}
            disabled={this.disabled}>{t('common:payment:payment_cmj_account')}</button>
        </div>
      </div>
    )
  }
}

ByWalletComponent.propTypes = {
  t: func,
  asAdmin: bool,
  payment: shape({
    advance: number,
    unpaid: number,
    total: number,
    balance: number
  })
}

export const ByWallet = translate()(ByWalletComponent)



// WEBPACK FOOTER //
// ./src/components/payment/ByWallet.js